import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HelpPopoverService {
  #helpSortKey = 'hottable-help-sort';
  #helpFilterKey = 'hottable-help-filter';

  isAllowShowSortHelp() {
    //return Cookie.get(this.#helpSortKey) === false;
  }

  isAllowShowFilterHelp() {
    // не показываем подсказку, так как есть баннер между турами воспользуйтесь фильтрами
    return false;
    // return Cookie.get(this.#helpFilterKey) === false;
  }

  setVisibleSortHelp() {
    //Cookie.set(this.#helpSortKey, '1', 90);
  }

  setVisibleFilter() {
    //Cookie.set(this.#helpFilterKey, '1', 90);
  }
}
